import { forwardRef } from "react";
import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { isWeb, styled } from "@tamagui/core";
import { ComponentWithViewTracking } from "../../helpers/analytics";
import { useAnchorOrButtonPress } from "../shared/anchorOrButton";
import { StyleableText } from "../Text/Text";
import { jsx } from "react/jsx-runtime";
const { link: linkTokens } = tokens, StyledLink = styled(StyleableText, {
  hoverStyle: {
    cursor: "pointer"
  },
  focusVisibleStyle: {
    outlineStyle: "solid",
    outlineWidth: linkTokens.borderWidth.state.default,
    outlineOffset: linkTokens.padding.state.focused.default,
    borderRadius: linkTokens.cornerRadius.state.focused
  },
  variants: {
    variant: (variant, { props }) => ({
      color: props.disabled ? linkTokens.color.content.state.inactive[variant] : linkTokens.color.content[variant],
      textDecorationLine: variant === "primary" ? "none" : "underline",
      hoverStyle: props.disabled ? void 0 : {
        color: linkTokens.color.content.state.hover[variant]
      },
      focusVisibleStyle: {
        outlineColor: variant === "secondaryInverse" ? linkTokens.color.border.state.inverse : linkTokens.color.border.state.default
      }
    }),
    disabled: {
      true: {
        pointerEvents: "none"
      }
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}), Link = forwardRef(function({
  size = "medium",
  children,
  href,
  onPress,
  openURL,
  analyticsName,
  trackImpression,
  ...props
}, ref) {
  const handlePress = useAnchorOrButtonPress({ href, onPress, openURL, analyticsName }), Component = /* @__PURE__ */ jsx(
    StyledLink,
    {
      href,
      tag: href ? "a" : "span",
      typography: linkTokens.typography[size],
      ...props,
      onPress: handlePress,
      children
    }
  );
  return isWeb && analyticsName && trackImpression ? /* @__PURE__ */ jsx(
    ComponentWithViewTracking,
    {
      Component,
      analyticsName,
      eventName: "linkViewEvent",
      ref
    }
  ) : Component;
});
export {
  Link
};
